import { z } from 'zod';
import { AttendanceStatus } from '@academia-apolo/shared-types';
// notes: tri-estado — string = fijar, null = borrar, ausente/undefined = NO tocar
// la nota existente. El bulk reenvía filas de clientes que pueden no conocer las
// notas; convertir "ausente" en borrado machacaba notas escritas desde otro cliente.
const attendanceNotes = z.string().max(500).nullable().optional();
export const markAttendanceSchema = z.object({
    student_id: z.string().uuid(),
    status: z.nativeEnum(AttendanceStatus),
    notes: attendanceNotes,
});
export const bulkMarkAttendanceSchema = z.object({
    records: z
        .array(z.object({
        student_id: z.string().uuid(),
        status: z.nativeEnum(AttendanceStatus),
        notes: attendanceNotes,
    }))
        .min(1)
        // Techo defensivo, por encima de cualquier clase real (las de "todos los
        // turnos" son la oposición entera). Con 100, una oposición de 101+ alumnos
        // hacía la lista imposible de guardar.
        .max(500)
        .superRefine((records, ctx) => {
        const seen = new Set();
        for (const [i, r] of records.entries()) {
            if (seen.has(r.student_id)) {
                // Postgres aborta el upsert entero ante el mismo student_id dos veces
                // ("cannot affect row a second time") → sin esto, 500 en vez de 400.
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [i, 'student_id'],
                    message: 'Alumno duplicado en la lista',
                });
            }
            seen.add(r.student_id);
        }
    }),
});
export const updateAttendanceSchema = z.object({
    status: z.nativeEnum(AttendanceStatus),
    notes: attendanceNotes,
});
//# sourceMappingURL=attendance.schema.js.map